var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconEye01 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 12 9"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M7.5 4.102a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 4.125S2.25 0 6 0s6 4.125 6 4.125S9.75 8.25 6 8.25 0 4.125 0 4.125M6 6.75A2.625 2.625 0 1 0 6 1.5a2.625 2.625 0 0 0 0 5.25"
})));
export default SvgIconEye01;